export default __webpack_public_path__ + "static/10-birthday-gift-ideas-for-hard-to-buy-people-ff739664d69a62d003a67a68173881f6.jpg";